import axiosInstance from '../common/axios';
const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function saveZone(data) {
  return axiosInstance.post(`${backendUrl}/api/zones`, data);
}

export async function updateZone(zoneId, data) {
  return axiosInstance.put(`${backendUrl}/api/zones/${zoneId}`, data);
}

export async function getAllZones() {
  return axiosInstance.get(`${backendUrl}/api/zones`);
}

export async function getAllZoneSummary() {
  return axiosInstance.get(`${backendUrl}/api/zones/all/summary`);
}



 export const deleteZone = async (id) => {
  const res = await axiosInstance.delete(`${backendUrl}/api/zones/${id}`);
  return res.data;
};



// Save Supplier Info
export async function saveZonePincode(data) {
  return axiosInstance.post(`${backendUrl}/api/zone-pincodes`, data);
}


// Save Supplier Info
export async function updateZonePincode(zoneId, data) {
  return axiosInstance.put(`${backendUrl}/api/zone-pincodes/${zoneId}`, data);
}

export async function getAllZonePincodes() {
  return axiosInstance.get(`${backendUrl}/api/zone-pincodes`);
}

 export const deleteZonePincode = async (id) => {
  const res = await axiosInstance.delete(`${backendUrl}/api/zone-pincodes/${id}`);
  return res.data;
  };